import MapSection from './MapSection';

export default MapSection;
